module.exports = __webpack_public_path__ + "static/media/MenuAnnotationVerification.aad8210a.svg";